import { useEffect, useRef } from 'react';
import { drawPolylineOnMap } from '../utils/mapOverlays';

export interface TrackPoint {
  lat: number;
  lng: number;
}

interface UsePolylineLifecycleArgs {
  map: google.maps.Map | null;
  mapLoaded: boolean;
  enabled: boolean;
  points: ReadonlyArray<TrackPoint> | undefined;
}

export function usePolylineLifecycle({
  map,
  mapLoaded,
  enabled,
  points,
}: UsePolylineLifecycleArgs): void {
  const polylineRef = useRef<google.maps.Polyline | null>(null);

  useEffect(() => {
    if (!map || !mapLoaded) return;

    if (polylineRef.current) {
      polylineRef.current.setMap(null);
      polylineRef.current = null;
    }

    if (enabled && points && points.length > 0) {
      polylineRef.current = drawPolylineOnMap(map, points);
    }

    return () => {
      if (polylineRef.current) {
        polylineRef.current.setMap(null);
        polylineRef.current = null;
      }
    };
  }, [map, mapLoaded, enabled, points]);
}
